import { graphql } from '@client/graphql/types';
import { useMutation } from '@apollo/client';

export const MUTATION = graphql(`
  mutation createTable($tableGroup: ID!, $data: CreateTable) {
    createTable(tableGroup: $tableGroup, data: $data) {
      name
      seats
    }
  }
`);

export function useCreateTable() {
  return useMutation(MUTATION, {
    refetchQueries: ['tableGroup'],
  });
}
